import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ============================================================================
// post-client-mod -- 文章列表项
// ============================================================================
import * as React from 'react';
import { PostStatusBadge } from './post-status-badge.js';
import { EditIcon, TrashIcon } from './icons.js';
import { getMarkdownExcerpt } from '../util/markdown.js';
/**
 * 文章列表项
 */
export function PostListItem({ post, onEdit, onDelete, showMeta = true }) {
    const [hovered, setHovered] = React.useState(false);
    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleDateString('zh-CN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    };
    const excerpt = getMarkdownExcerpt(post.content, 80);
    return (_jsxs("div", { style: {
            ...styles.container,
            backgroundColor: hovered ? '#f9fafb' : '#ffffff',
            borderColor: hovered ? '#d1d5db' : '#e5e7eb',
        }, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), children: [_jsxs("div", { style: styles.content, children: [_jsxs("div", { style: styles.titleRow, children: [_jsx("h4", { style: styles.title, children: post.title }), _jsx(PostStatusBadge, { status: post.status })] }), _jsx("p", { style: styles.excerpt, children: excerpt }), showMeta && (post.categorySlug || post.tagSlugs?.length > 0) && (_jsxs("div", { style: styles.metaRow, children: [post.categorySlug && (_jsx("span", { style: styles.categoryBadge, children: post.categorySlug })), post.tagSlugs?.map(slug => (_jsxs("span", { style: styles.tagBadge, children: ["#", slug] }, slug)))] })), _jsxs("span", { style: styles.date, children: ["\u66F4\u65B0\u4E8E ", formatDate(post.updatedAt)] })] }), _jsxs("div", { style: styles.actions, children: [_jsx("button", { onClick: () => onEdit(post), title: "\u7F16\u8F91", style: styles.actionButton, children: _jsx(EditIcon, {}) }), _jsx("button", { onClick: () => onDelete(post), title: "\u5220\u9664", style: { ...styles.actionButton, color: '#ef4444' }, children: _jsx(TrashIcon, {}) })] })] }));
}
const styles = {
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '16px',
        padding: '16px',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        transition: 'all 0.15s ease',
    },
    content: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        minWidth: 0,
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    title: {
        margin: 0,
        fontSize: '15px',
        fontWeight: 600,
        color: '#111827',
        lineHeight: '22px',
    },
    excerpt: {
        margin: 0,
        fontSize: '13px',
        color: '#6b7280',
        lineHeight: '20px',
    },
    metaRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px',
    },
    categoryBadge: {
        padding: '2px 8px',
        backgroundColor: '#f0fdf4',
        color: '#166534',
        borderRadius: '4px',
        fontSize: '11px',
        fontWeight: 500,
        border: '1px solid #bbf7d0',
    },
    tagBadge: {
        padding: '2px 6px',
        borderRadius: '4px',
        fontSize: '11px',
        color: '#6366f1',
        backgroundColor: '#eef2ff',
        border: '1px solid #c7d2fe',
    },
    date: {
        fontSize: '12px',
        color: '#9ca3af',
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        flexShrink: 0,
    },
    actionButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '32px',
        border: 'none',
        borderRadius: '6px',
        backgroundColor: 'transparent',
        color: '#6b7280',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
    },
};
//# sourceMappingURL=post-list-item.js.map